<template>
  <div>
    <h4>Offices</h4>
    <p>Add, remove and edit office location(s).</p>
    <button
      class="btn-default btn-create"
      style="margin-top: 0px; margin-left: 0px;"
      type="button"
      @click="createNewOffice"
    >
      Create new office
    </button>
    <div v-for="(office, index) in officeList">
      <inputForm v-bind:key="office.id" :index="index" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import textInput from "./textInput.vue";
import officesInputForm from "./officesInputForm.vue";

export default {
  name: "offices",
  components: {
    textInput: textInput,
    inputForm: officesInputForm
  },
  data: function() {
    return {
      offices: this.officeList
    };
  },
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain",
      countries: "countries"
    }),
    officeList: function() {
      return this.getProperty(["offices"]);
    }
  },
  methods: {
    ...mapMutations({
      deleteProviderProperty: "deleteEditedProviderPropertyByKeyChain"
    }),
    createNewOffice: function() {
      this.$store.commit("createNewProviderProperty", "offices");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/elements/offices.vue